export default "__VITE_ASSET__imG_KW8g__"